module.exports = {
    contractarriveT:'Contract Expiring Reminder',
    contContent:'Kindly note that there is an agreement/IO/contract that will expire soon. Please contact your BD Manager to renew it.',
    gotit:'I got it!',
    seeit:'View Now',
    updatetitle:'Your material has been updated.',
    updatenotice:'You have material updates, please check the material interface link for details.',
    billtitle:'Bill/Invoice Due Reminder',
    billcontent:'Kindly note that your invoice will soon be due. Please check it and arrange payment accordingly.',
    deletes:'Delete',
    passed:'Approved',
    unpassed:'Under approval/Approval failed',
    Time:'Time',
    Invoice:'Invoice',
    Status:'Status',
    Operation:'Operation',
    invoiceIm:'Invoice Information',
    contractIm: 'Contract Information',
    contractTime:'Contract Expiry Time',
    contractAndInvoice:'Contract & Invoice Information',
    off:'Put Away',
    open:'View Team',
    expired:'Expired',
    unexpired:'Unexpired',
    notice_before:'We regret that you are stopping this process',
    notice_after:',and look forward to working with you again',
    jumptip:'Jump to the invoice details page',
    jumptip2:'Jump to the invoice details page',
    error:'File address resolution error',
    tracktitle:'KOL Tracking Reminder',
    closetitle:'KOL Tracking Close',
    trackcontent:'You have a new process update, please check it in time',
    closecontent:'You have a process closed, please check it in time',
    nofiles:'The file has been deleted or been unreleased',
    canread:'Can not be available available'
}



// WEBPACK FOOTER //
// ./src/i18n/modules/notification/en.js